import { PureComponent } from 'react'
import _ from 'lodash'

import cx from 'classnames'
import PropTypes from 'prop-types'
import styles from './index.css'
import { MenuSelect, ItemTag } from '@vzmi/shp_shared_compo'
import { AntdCheckbox } from '../Form'

const dataRole = 'checkbox-menu-select'

class CheckboxMenuSelect extends PureComponent {
  getItemInputPickerValue = () => {
    const { value = [], disabled } = this.props
    const localValues = _.toArray(value)

    return _.map(
      localValues,
      (localValue, idx) => {
        const key = `${localValue}__${idx}`
        const stopPropagation = e => e.stopPropagation()
        const removeTheItem = () => this.removeItem(localValue)

        return (
          <ItemTag
            key={key}
            color='#5478fc'
            closable={!disabled}
            onClose={removeTheItem}
            /**
              stop the click action from propagating to parent popup so it won't trigger popup close
            */
            onClick={stopPropagation}
          >
            {localValue}
          </ItemTag>
        )
      }
    )
  }

  handleChange = (value) => {
    this.props.onChange(_.isEmpty(value) ? null : value)
  }

  handleCustomInputSubmit = (inputValue, foundInputOption) => {
    const { normalizeCustomInput, multipleCustomInput, value = [], options } = this.props
    const localInputValue = normalizeCustomInput(inputValue)
    const inputValOpt = { value: localInputValue }
    if (multipleCustomInput) {
      this.handleItemMenuSelect(inputValOpt)
    } else {
      // 如果自訂選項已經存在列表，則加入並刪除自訂選項
      const optionsValArr = _.map(options, 'value')
      let copiedValue = [...value]
      if (foundInputOption) {
        const customInput = this.menuSelect.getCustomInputByValue()
        if (customInput) {
          setImmediate(() => {
            this.menuSelect.reinstateCustomInput()
            this.removeItem(customInput)
          })
        }
      }
      copiedValue = _.pullAllBy(_.uniq(copiedValue), _.differenceBy(value, optionsValArr))
      if (_.isString(localInputValue) && !_.isEmpty(localInputValue)) {
        this.handleChange(_.uniq([...copiedValue, localInputValue]))
      } else {
        this.handleChange(_.uniq([...copiedValue]))
      }
    }
  }

  handleItemMenuSelect = (selectedItemOption, menuIndex) => {
    const optionValue = _.get(selectedItemOption, 'value')
    if (optionValue) {
      const { value = [] } = this.props
      if (_.includes(value, optionValue)) {
        this.removeItem(optionValue)
      } else {
        this.handleChange(_.uniq([...value, optionValue]))
      }
    }
  }

  removeItem = (removeValue) => {
    const { value = [] } = this.props
    const localValues = _.toArray(value)
    const copiedArr = [...localValues]
    _.pull(copiedArr, removeValue)
    this.handleChange(copiedArr)
  }

  render () {
    const { options, value = [], className, popupClassName, ...restProps } = this.props

    return (
      <MenuSelect
        {...restProps}
        value={value}
        ref={r => (this.menuSelect = r)}
        inputPickerValue={this.getItemInputPickerValue()}
        className={cx(styles.CheckboxMenuSelect, className)}
        popupClassName={cx(styles.CheckboxMenuSelectPopup, dataRole, popupClassName)}
        options={options}
        onSelect={this.handleItemMenuSelect}
        onCustomInputSubmit={this.handleCustomInputSubmit}
        closeOnSelect={false}
        closeOnCustomInputSubmit={false}
        optionRenderer={(option, menuIndex) => {
          const {
            value: optVal,
            label: optLabel,
            key: optKey
          } = option

          return (
            <AntdCheckbox
              key={optKey}
              value={optVal}
              checked={_.includes(value, optVal)}
              data-role={`${dataRole}-item`}
            >
              {optLabel}
            </AntdCheckbox>
          )
        }}
      />
    )
  }
}

CheckboxMenuSelect.propTypes = {
  // value: PropTypes.array,
  'data-role': PropTypes.string,
  multipleCustomInput: PropTypes.bool,
  onChange: PropTypes.func.isRequired
}

CheckboxMenuSelect.defaultProps = {
  multipleCustomInput: true,
  onChange () { },
  'data-role': dataRole
}

export default CheckboxMenuSelect
